"use client";
import ErrorBoundary from "@/components/framework/errorboundary/ErrorBoundary";
import dynamic from 'next/dynamic';
import styles from "./SoMe.module.css";

//#region [Props]
type InstagramProps = {
    value: {
        instagramPostId: string;
    }
};
//#endregion

//#region [Component]
const DynamicInstagramEmbed = dynamic(() =>
    import('react-social-media-embed').then((mod) => mod.InstagramEmbed),
    { ssr: false }
);

export default function Instagram({ value }: InstagramProps) {
    if (!value?.instagramPostId) {
        return null;
    }
    return <div className={styles.container}>
        <ErrorBoundary>
            <DynamicInstagramEmbed url={`https://www.instagram.com/p/${value.instagramPostId}/`} width="100%" />
        </ErrorBoundary>
    </div>;
}
//#endregion